<template>
  <div class="scroll-wrapper" id="scrollView" :style="{'padding-top': top + 'px', 'padding-bottom': bottom + 'px'}">
<!--    <div class="scroll-wrapper" id="scrollView" :style="{top: top + 'px', bottom: bottom + 'px'}">-->
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'ScrollBox',
  props: {
    top: {
      type: Number,
      default: 60
    },
    bottom: {
      type: Number,
      default: 50
    }
  },
  mounted() {
    // this.$common.fixBottom()
  }
}
</script>

<style lang="less" scoped>
.scroll-wrapper{
  /*position: fixed;*/
  /*left: 0;*/
  /*right: 0;*/
  /*overflow: auto;*/
  /*background: #fff;*/
  /*-webkit-overflow-scrolling: touch;*/
}
</style>



// WEBPACK FOOTER //
// src/modules/ScrollBox/index.vue